import { ServerResponse } from 'http';
import { TargetCookie } from '@adobe/target-nodejs-sdk';
import { setCookie } from 'nookies';
import { TargetResponseCookies } from './types';

export const applyTargetCookies = (res: ServerResponse, offersResult: TargetResponseCookies) => {
  setTargetCookie(res, offersResult.domain, offersResult.targetCookie);
  setTargetCookie(res, offersResult.domain, offersResult.targetLocationHintCookie);
};

const setTargetCookie = (res: ServerResponse, domain: string | undefined, cookie: TargetCookie) => {
  setCookie({ res }, cookie.name, cookie.value, {
    maxAge: cookie.maxAge * 1000,
    domain: domain,
    httpOnly: false,
    path: '/',
  });
};
